import ProductListItem from "core/components/ProductListItem";
import { useCustomNavigate } from "core/hooks/useCustomNavigate";
import { _t } from "core/language";
import { RouterName } from "core/router";
import { getYouTubeThumbnail } from "core/utils/helper";
// import { useUser } from "modules/Auth/hooks";
import { useGoToRecipeDetail } from "modules/Recipes/hooks/recipe";
import React, { useEffect, useState } from "react";
import MoreIcon from "../assets/icon/more.svg";
import { useFavoritesMain, useRemoveFavoriteById } from "../hooks";
import MainNodata from "./NodataComponent";
import SectionSkeleton from "./SectionSkeleton";
import { useIsAuth } from "modules/Auth/hooks";
import FavoriteNoAuth from "./FavoriteNoAuth";
import IconSectionFavorite from "./icon/IconSectionFavorite";
// import IconTitle from "../assets/images/icon_section_favorite.svg";

const FavoritesSection = ({refresh}:any) => {
  //get user id from local storage
  const goToDetail = useGoToRecipeDetail(RouterName.INGREDIENT_RECIPE_DETAIL);
  const navigate = useCustomNavigate();
  const isAuth = useIsAuth();
  // const user = useUser();
  //console.log("user", user);
  const [paramsFavoritesMain, setParamsFavoritesMain] = useState({
    refresh: Date.now(),
  });

  useEffect(() => {
    setParamsFavoritesMain({
      refresh: refresh,
    })
  }, [refresh]);

  const [favorites, loading] = useFavoritesMain(paramsFavoritesMain);

  const handleClick = (data: any) => {
    //console.log("handleClick", data);
    goToDetail(data);
  };

  const handleRemove = useRemoveFavoriteById();
  const handleClickNote = (id: any) => {
    handleRemove?.(id);
  };

  const hasData = favorites?.length > 0;
  if (!isAuth) {
    return <FavoriteNoAuth />;
  }
  return (
    <section className="mt-2 py-[20px] w-full bg-white">
      <div
        className="pl-[16px]"
        onClick={() => navigate(RouterName.FAVORITES)}
      >
        <p className="z-10 text-[#777777] text-[12px] font-normal mb-[2px]">
        {_t("main.favorite_section_title")}
        </p>
        <h1 className="text-[16px] font-bold text-[#111111] flex items-center">
          <div className="mr-1">
            <IconSectionFavorite />
          </div>
          {_t("main.favorite_section_description")}
        </h1>
        <img className="mr-2 hidden" src={MoreIcon} alt="" />
      </div>
      <div className="flex flex-col items-start overflow-x-scroll no-scrollbar px-4">
        <div className="flex mt-3.5 gap-2">
          {loading && !hasData && <SectionSkeleton width={160} height={160} />}
          {favorites.map((favorite: any, index: number) => {
            const _img = favorite?.video_id
              ? getYouTubeThumbnail(favorite?.video_id)
              : null;

            return (
              <ProductListItem
                key={index}
                className="w-[140px] mb-0 h-[140px]"
                image={_img}
                showNote
                // active={
                //   favorite.user_recipe_favorite[0]?.user_id === user?.userInfo?.id
                // }
                active={true}
                dataItem={favorite}
                name={favorite.title}
                handleClick={handleClick}
                handleClickNote={handleClickNote}
                showConfirmRemoveNote
                {...favorite}
              />
            );
          })}
        </div>
        <MainNodata
          loading={loading}
          data={favorites}
          text={_t("main.no_data")}
        />
      </div>
    </section>
  );
};

export default FavoritesSection;
